import axios from "axios";

export const state = {
    schooldepartments: [],
};

export const getters = {
    schooldepartments: state => state.schooldepartments,
};

export const mutations = {
    setDepartment(state, newValue) {
        state.schooldepartments = newValue
    },
};

export const actions = {
    fetchSchoolDepartments({ commit }) {
        axios.get('/schooldepartments').then(res => {
            commit('setDepartment', res.data.schooldepartments);
        })
    },
};